import axios from "axios";
import i18next from 'i18next';

import {store} from "../configureStore";
import {
    botsReloadBot
} from '../actions/Dashboard'
import {renderErrorsAsString} from "../Components/utils";
import {toast} from "react-toastify";
import {ajax} from "rxjs/ajax";


export function loadBots() {
    return ajax.get(
        process.env.REACT_APP_API_URL + `bot/bots/?shop_id=${store.getState().Shops.activeShop.id}`,
        {
            Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            'Content-Type': 'application/json',

        }
    )
}

export function reLoadBots() {
    return ajax.get(
        process.env.REACT_APP_API_URL + `bot/bots/?shop_id=${store.getState().Shops.activeShop.id}`,
        {
            Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            'Content-Type': 'application/json',

        }
    )
}


export function reloadBot(dispatch, botId) {
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        timeout: 30000,
        headers: {
            Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            'Content-Type': 'application/json',
        },
    });

    return instance.get(`bot/bots/?shop_id=${store.getState().Shops.activeShop.id}&id=${botId}`).then(({data}) => {
        if (data && data?.result?.results?.length) {
            dispatch(botsReloadBot(data.result.results[0]))
        }
        return data;
    })
}
